// Qué hace la tienda con un 503 de /session (Tarea 2b.3, R2).
//
// Un 503 «de siempre» —North sin credenciales, gateway caído, sin cuerpo— es el modo
// simulación del checkout, como en main. Dos excepciones, que son fallas REALES:
//   - `pricing_unavailable`: el cotizador no pudo leer algo antes de cobrar (el mixto,
//     el alcohol del cupón, las variantes del súper). Nadie pagó; el cliente reintenta.
//     Simular ahí mostraría un «pago simulado» sobre un pedido de verdad.
//   - `shipping_intent_unavailable` con un envío en vuelo (como main: sin envío no se
//     mira ese código).

export type Session503Outcome =
  | { kind: 'simulation' }
  | { kind: 'retry'; message: string | null }
  | { kind: 'ship_failed' }

export function session503Outcome(body: unknown, hasShippingQuote: boolean): Session503Outcome {
  const b = body as { error?: unknown; message?: unknown } | null
  if (b?.error === 'pricing_unavailable') {
    return { kind: 'retry', message: typeof b.message === 'string' && b.message.trim() ? b.message : null }
  }
  if (hasShippingQuote && b?.error === 'shipping_intent_unavailable') return { kind: 'ship_failed' }
  return { kind: 'simulation' }
}
